import React, { ReactElement, PropsWithChildren, useRef, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import TopNavigation from './components/TopNavigation';
import Footer from './components/Footer';
import { useLocation } from 'react-router-dom';
import { HeaderFooterProvider, useHeaderFooter } from './contexts/HeaderFooterContext';

const WrapperInner = ({ children }: PropsWithChildren): ReactElement => {
  const { pathname } = useLocation();
  const headerRef = useRef<HTMLElement>(null);
  const footerRef = useRef<HTMLElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  const { showHeader, showFooter } = useHeaderFooter();

  useEffect(() => {
    if (showHeader) {
      setHeaderHeight(headerRef.current?.offsetHeight ?? 0);
    } else {
      setHeaderHeight(0);
    }

    if (showFooter) {
      setFooterHeight(footerRef.current?.offsetHeight ?? 0);
    } else {
      setFooterHeight(0);
    }
  }, [showHeader, showFooter]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Box>
      {showHeader && <TopNavigation ref={headerRef} />}

      <Box minHeight={`calc(100vh - ${footerHeight + headerHeight}px)`} mt={showHeader ? `${headerHeight}px` : 0}>
        {children}
      </Box>

      {showFooter && <Footer ref={footerRef} />}
    </Box>
  );
};

const Wrapper = ({ children }: PropsWithChildren): ReactElement => {
  return (
    <HeaderFooterProvider>
      <WrapperInner>{children}</WrapperInner>
    </HeaderFooterProvider>
  );
};

export default Wrapper;
